module.exports = __webpack_public_path__ + "img/filter_2.44472b33.svg";